import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.5 6L9.00003 2.5H6.94003L2.50003 6V13.5H13.5V6Z",
		stroke: "black",
		strokeWidth: 1.09091,
		strokeLinejoin: "bevel"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.5 5.5V2.5H10.5V3.5",
		stroke: "black",
		strokeWidth: 1.09091,
		strokeLinejoin: "bevel"
	})]
});
export default SvgHome;
